export const formatDate = (forecastDate, user_timezone= false, year = false, showTime = true, showWeekday = true) => {
    const options = { year: undefined, month: 'short', day: 'numeric' };
    if (showWeekday) options.weekday = 'short';
    let timeOptions;
    if (user_timezone) {
        timeOptions = {year: undefined, timeZone: user_timezone, timeZoneName: 'short', hour: 'numeric', minute: 'numeric' };
    } else {
        timeOptions = {year: undefined, hour: 'numeric', minute: 'numeric' };
    }
    return `${showTime ? `${forecastDate.toLocaleString("en-US", timeOptions)} | ` : ''}${forecastDate.toLocaleString("en-US", options)}${year ? `, ${forecastDate.getFullYear()}` : ''}`;
};

// Get the difference between two timezones in milliseconds
export const timeDifference = (tz_one, tz_two) => {
    return new Date(new Date().toLocaleString('en-US', { timeZone: tz_one })).getTime() - new Date(new Date().toLocaleString('en-US', { timeZone: tz_two })).getTime()
};

// Add the difference between two timezones to a date
export const adjustHoursByTimezone = (date, tz_one, tz_two) => {
    return addHoursToDate(date, timeDifference(tz_one, tz_two));
};
// Add the difference between two timezones to a date
export const addHoursToDate = (date, hours, time=true) => {
    if (time) {
        return new Date(new Date(date).setTime(new Date(date).getTime() + hours));
    } else {
        return new Date(new Date(date).setHours(new Date(date).getHours() + hours));
    }
};

export const addDaysToDate = (date, days) => {
    return new Date(new Date(date).setDate(new Date(date).getDate() + days))
};

/**
* Format a date object to the expected string for quasar's date input.
*/
export const formatInputDate = (date, separator = '/', dayOffset = 0) => {
    let modDate = new Date(date.setDate(date.getDate() + dayOffset));
    let month = `${modDate.getMonth() + 1}`;
    if (month.length < 2) {
        month = `0${month}`;
    }
    const year = modDate.getFullYear();
    let day = `${modDate.getDate()}`;
    if (day.length < 2) {
        day = `0${day}`;
    }
    return year + separator + month + separator + day;
};
